<template>
  <b-card footer-tag="footer">
    <!-- Card body -->
    <b-card-title title-tag="h3" class="mb-3">
      <span v-if="recentIncidents.length > 0" style="color: #fb6340;">
        {{ numAffectedIncidents }} Recent Incident{{
          numAffectedIncidents > 1 ? "s" : ""
        }}
        In {{ numAffectedComponents }} Component{{
          numAffectedComponents > 1 ? "s" : ""
        }}
      </span>
      <span v-else style="color: #4fd69c;">
        No Recent Incidents
      </span>
    </b-card-title>
    <b-card-text>
      <div v-if="recentIncidents.length > 0">
        <p>
          <strong>
            {{ latestIncident.component.name }}
          </strong>
          -
          <a :href="latestIncident.incident.shortlink">
            {{ latestIncident.incident.name }}
          </a>
        </p>
      </div>

      <p v-else>
        🎉 Everything has been looking great.
      </p>
    </b-card-text>
    <template v-slot:footer v-if="recentIncidents.length > 0">
      <p class="text-muted mb-0">
        Updated at
        {{ latestIncident.incident.updatedAt | moment("h:mm a on MMM D") }}
      </p>
    </template>
  </b-card>
</template>
<script>
import moment from "moment";

export default {
  name: "recent-incidents",
  props: ["website", "uptimeObj"],
  data() {
    return {
      uptimeData: [],
      rectWidth: 7,
      recentIncidents: [],
      latestIncident: {}
    };
  },
  computed: {},
  methods: {},
  watch: {
    uptimeObj: function (uptimeObj) {
      const incidents = [];

      let numAffectedComponents = {};
      let numAffectedIncidents = 0;

      for (const incidentObj of uptimeObj) {
        const daysAgo = moment().diff(incidentObj.incident.updatedAt, "days");
        if (daysAgo <= 3) {
          incidents.push(incidentObj);
          numAffectedComponents[incidentObj.component.id] = true;
          numAffectedIncidents++;
        }
      }

      incidents.sort((first, second) => {
        return (
          new Date(first.incident.createdAt).getTime() -
          new Date(second.incident.createdAt).getTime()
        );
      });

      this.recentIncidents = incidents;
      if (this.recentIncidents.length > 0) {
        this.latestIncident = incidents[incidents.length - 1];
      }

      console.log("RECENT INCIDENTS");
      console.log(incidents);

      this.numAffectedComponents = Object.keys(numAffectedComponents).length;
      this.numAffectedIncidents = numAffectedIncidents;

      console.log(this.numAffectedComponents);
      console.log(this.numAffectedIncidents);
      console.log("Retrieved new uptime obj!");
      console.log(uptimeObj);
    }
  },
  async mounted() {}
};
</script>
<style>
.uptime-subheader {
  color: #9facbb !important;
  font-size: 14px;
}
</style>
